(() => {
  const root = document.querySelector('[data-tr-pdp]');
  if (!root) return;
  const dataEl = document.querySelector('[data-product-json]');
  const data = dataEl ? JSON.parse(dataEl.textContent) : { variants: [] };
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const behavior = reduce ? 'auto' : 'smooth';

  /* ---------- Gallery ---------- */
  const track = root.querySelector('[data-gallery-track]');
  const count = root.querySelector('[data-gallery-count]');
  const prev = root.querySelector('[data-gallery-prev]');
  const next = root.querySelector('[data-gallery-next]');
  const slides = track ? Array.from(track.children) : [];

  const step = () => (slides[1] ? slides[1].offsetLeft - slides[0].offsetLeft : track.clientWidth);
  const currentIndex = () => Math.round(track.scrollLeft / step());
  const updateGallery = () => {
    if (!track) return;
    const i = Math.min(currentIndex(), slides.length - 1);
    if (count) count.textContent = `${i + 1}/${slides.length}`;
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
  };
  if (track) {
    prev?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior }));
    next?.addEventListener('click', () => track.scrollBy({ left: step(), behavior }));
    track.addEventListener('scroll', () => requestAnimationFrame(updateGallery), { passive: true });
    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); next?.click(); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); prev?.click(); }
    });
    window.addEventListener('resize', updateGallery);
    updateGallery();
  }
  const showMedia = (mediaId) => {
    if (!track || !mediaId) return;
    const slide = track.querySelector(`[data-media-id="${mediaId}"]`);
    if (slide) track.scrollTo({ left: slide.offsetLeft - slides[0].offsetLeft, behavior });
  };

  /* ---------- Variants ---------- */
  const form = root.querySelector('[data-product-form]');
  if (!form) return;
  const idInput = form.querySelector('[data-variant-id]');
  const addBtn = form.querySelector('[data-add-btn]');
  const addLabel = form.querySelector('[data-add-label]');
  const errorEl = form.querySelector('[data-form-error]');
  const priceEl = root.querySelector('[data-price]');
  const colorName = root.querySelector('[data-color-name]');
  const groups = Array.from(form.querySelectorAll('[data-option-index]'));
  const money = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: data.currency || 'USD' });

  const selected = () => {
    const out = [];
    groups.forEach((g) => {
      const idx = Number(g.dataset.optionIndex);
      const checked = g.querySelector('input:checked');
      const select = g.querySelector('select');
      out[idx] = checked ? checked.value : select ? select.value : '';
    });
    return out;
  };
  const findVariant = (opts) => data.variants.find((v) => v.options.every((o, i) => o === opts[i]));
  const firstMissing = (opts) => groups.find((g) => !opts[Number(g.dataset.optionIndex)]);

  const render = () => {
    const opts = selected();
    errorEl.hidden = true;
    form.querySelectorAll('select').forEach((s) => s.removeAttribute('aria-invalid'));
    const v = findVariant(opts);
    // Fall back to a variant matching the colour for price/media while sizes are unchosen.
    const ref = v || (data.colorIndex !== null ? data.variants.find((x) => x.options[data.colorIndex] === opts[data.colorIndex]) : null);
    if (ref && priceEl) {
      priceEl.innerHTML = (ref.compare > ref.price ? `<s>${money.format(ref.compare / 100)}</s>` : '') +
        `<span data-price-value>${money.format(ref.price / 100)}</span>`;
    }
    if (v) {
      idInput.value = v.id;
      addBtn.disabled = !v.available;
      addLabel.textContent = v.available ? 'Add to bag' : 'Sold out';
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url);
    } else {
      addBtn.disabled = false;
      addLabel.textContent = 'Add to bag';
    }
    return { opts, v, ref };
  };

  form.addEventListener('change', (e) => {
    if (!e.target.matches('[data-option-input]')) return;
    const { ref } = render();
    const isColor = e.target.type === 'radio';
    if (isColor) {
      if (colorName) colorName.textContent = e.target.value;
      if (ref) showMedia(ref.media);
    }
  });

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const { opts, v } = render();
    const missing = firstMissing(opts);
    if (missing) {
      const sel = missing.querySelector('select');
      const label = sel ? sel.options[0].textContent.replace(/^Select /i, '') : 'an option';
      errorEl.textContent = `Choose a ${label} first.`;
      errorEl.hidden = false;
      if (sel) { sel.setAttribute('aria-invalid', 'true'); sel.focus(); }
      return;
    }
    if (!v || !v.available) return;
    addBtn.disabled = true;
    addLabel.textContent = 'Adding…';
    try {
      const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }),
      });
      if (!res.ok) {
        const body = await res.json().catch(() => ({}));
        throw new Error(body.description || 'This item could not be added.');
      }
      addBtn.classList.add('is-added');
      addLabel.textContent = 'Added — going to bag';
      setTimeout(() => { window.location.href = `${window.Shopify?.routes?.root || '/'}cart`; }, 500);
    } catch (err) {
      errorEl.textContent = err.message;
      errorEl.hidden = false;
      addBtn.disabled = false;
      addLabel.textContent = 'Add to bag';
    }
  });

  render();

  /* ---------- Viewed together carousel ---------- */
  root.querySelectorAll('[data-carousel]').forEach((c) => {
    const t = c.querySelector('[data-carousel-track]');
    const p = c.querySelector('[data-carousel-prev]');
    const n = c.querySelector('[data-carousel-next]');
    const bar = c.querySelector('[data-carousel-progress]');
    const cardStep = () => (t.children[1] ? t.children[1].offsetLeft - t.children[0].offsetLeft : t.clientWidth);
    const update = () => {
      const max = t.scrollWidth - t.clientWidth;
      const ratio = t.clientWidth / t.scrollWidth;
      if (bar) {
        bar.style.width = `${Math.max(ratio, 0.1) * 100}%`;
        bar.style.left = `${max > 0 ? (t.scrollLeft / max) * (1 - ratio) * 100 : 0}%`;
      }
      p.disabled = t.scrollLeft <= 2;
      n.disabled = t.scrollLeft >= max - 2;
    };
    p.addEventListener('click', () => t.scrollBy({ left: -cardStep(), behavior }));
    n.addEventListener('click', () => t.scrollBy({ left: cardStep(), behavior }));
    t.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
    window.addEventListener('resize', update);
    update();
  });
})();
